<template>
  <nav class="navbar">
    <div class="nav-brand">
      <!-- <img src="@/assets/logo-2.png" alt="Riddhi Logo" class="brand-logo" /> -->
      <router-link to="/" class="brand-link">Riddhi</router-link>
    </div>

    <!-- Hamburger Menu Button -->
    <button
      class="hamburger-menu"
      @click="toggleMobileMenu"
      :class="{ active: isMobileMenuOpen }"
      aria-label="Toggle navigation menu"
    >
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
    </button>

    <!-- Mobile Menu Overlay -->
    <div
      class="mobile-menu-overlay"
      :class="{ 'mobile-open': isMobileMenuOpen }"
      @click="closeMobileMenu"
    ></div>

    <!-- Navigation Links -->
    <div class="nav-links" :class="{ 'mobile-open': isMobileMenuOpen }">
      <router-link to="/" class="nav-link" @click="closeMobileMenu"
        >Home</router-link
      >
      <router-link to="/about" class="nav-link" @click="closeMobileMenu"
        >About</router-link
      >
      <router-link to="/services" class="nav-link" @click="closeMobileMenu"
        >Services</router-link
      >
      <router-link to="/blogs" class="nav-link" @click="closeMobileMenu"
        >Blogs</router-link
      >

      <!-- Mobile Dropdown for Tools -->
      <div class="dropdown" :class="{ 'mobile-dropdown': isMobile }">
        <button
          class="nav-link dropdown-toggle"
          @click="toggleDropdown"
          :class="{ active: isDropdownOpen }"
        >
          Tools
          <i
            class="fas fa-chevron-down"
            :class="{ rotated: isDropdownOpen }"
          ></i>
        </button>
        <div class="dropdown-menu" :class="{ 'mobile-open': isDropdownOpen }">
          <router-link
            to="/tools/retirement-calculator"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            Retirement Planning
          </router-link>
          <router-link
            to="/tools/cagr-calculator"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            Calculate CAGR
          </router-link>
          <router-link
            to="/tools/health-report"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            Financial Health Report
          </router-link>
        </div>
      </div>

      <router-link to="/contact" class="nav-link" @click="closeMobileMenu"
        >Contact</router-link
      >

      <template v-if="isAuthenticated">
        <router-link to="/dashboard" class="nav-link" @click="closeMobileMenu"
          >Dashboard</router-link
        >
        <router-link
          v-if="isAdmin"
          to="/admin"
          class="nav-link admin-link"
          @click="closeMobileMenu"
        >
          <i class="fas fa-user-shield"></i> Admin
        </router-link>
        <a @click.prevent="handleLogout" class="nav-link logout-link">
          <i class="fas fa-sign-out-alt"></i> Logout
        </a>
      </template>
      <template v-else>
        <a @click.prevent="handleLogin" class="nav-link login-link">Login</a>
      </template>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { awsConfig } from "../aws-config";

// import { signOut } from "@aws-amplify/auth";
// import { Auth } from "aws-amplify";

export default {
  name: "NavBar",
  data() {
    return {
      isMobileMenuOpen: false,
      isDropdownOpen: false,
      isMobile: false,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "getUser"]),
    isAdmin() {
      return this.getUser?.isAdmin === true;
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    ...mapActions(["logout"]),
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.isMobileMenuOpen = false;
        this.isDropdownOpen = false;
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      document.body.style.overflow = "";
    },
    toggleDropdown() {
      if (this.isMobile) {
        this.isDropdownOpen = !this.isDropdownOpen;
      }
    },
    async handleLogout() {
      // try {
      //   await signOut();
      //   await this.logout();
      //   if (this.$route.meta.requiresAuth) {
      //     this.$router.push("/");
      //   }
      // } catch (error) {
      //   console.error("Error signing out:", error);
      // }
      try {
        // Configuration from aws-config.js

        // const clientId = "5l9beaq1niaeg70jag9sd6u29a";
        // const domain =
        //   "riddhi-dev-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com";
        // const clientId = "2g84dlu4d6uqsigg1pvfcojnuj";
        // const domain =
        //   "riddhi-preprod-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com";
        const clientId = awsConfig.Auth.Cognito.userPoolClientId;
        const domain = awsConfig.Auth.Cognito.oauth.domain;
        const redirectUri = encodeURIComponent(window.location.origin);

        // Clear local auth state first
        await this.logout();

        // Redirect to Cognito logout URL
        window.location.href = `https://${domain}/logout?client_id=${clientId}&logout_uri=${redirectUri}`;
      } catch (error) {
        console.error("Error signing out:", error);
      }
    },
    handleLogin() {
      // Get these values from your aws-config.js
      // const clientId = "5l9beaq1niaeg70jag9sd6u29a";
      // const domain =
      //   "riddhi-dev-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com";
      // const clientId = "2g84dlu4d6uqsigg1pvfcojnuj";
      // const domain =
      //   "riddhi-preprod-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com";
      const clientId = awsConfig.Auth.Cognito.userPoolClientId;
      const domain = awsConfig.Auth.Cognito.oauth.domain;

      console.log("clientId", clientId);
      console.log("domain", domain);

      const redirectUri = encodeURIComponent(window.location.origin);

      console.debug("Redirect URI:", redirectUri);
      const scopes = encodeURIComponent(
        "phone openid profile email api.crm.riddhi.co.in/admin api.crm.riddhi.co.in/read api.crm.riddhi.co.in/write aws.cognito.signin.user.admin email openid phone profile"
      );

      // Construct the Cognito hosted UI URL
      const authorizeUrl = `https://${domain}/oauth2/authorize?client_id=${clientId}&response_type=code&scope=${scopes}&redirect_uri=${redirectUri}`;

      console.log("Redirecting to Cognito Hosted UI:", authorizeUrl);

      // Redirect to Cognito Hosted UI
      window.location.href = authorizeUrl;
    },
  },
};
</script>

<style scoped>
.navbar {
  background-color: #072ac8;
  padding: 1rem;
  padding-left: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1000;
}

.nav-brand {
  font-size: 1.5rem;
  font-weight: bold;
  z-index: 1001;
}

.brand-link {
  color: white;
  text-decoration: none;
}

/* Hamburger Menu Styles */
.hamburger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.hamburger-line {
  width: 25px;
  height: 3px;
  background-color: white;
  transition: all 0.3s ease;
  transform-origin: center;
}

.hamburger-menu.active .hamburger-line:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.hamburger-menu.active .hamburger-line:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.active .hamburger-line:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

/* Mobile Menu Overlay */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.mobile-menu-overlay.mobile-open {
  opacity: 1;
  visibility: visible;
}

.nav-links {
  display: flex;
  gap: 1rem;
  align-items: center;
}

/* Ensure mobile menu is hidden on desktop */
@media (min-width: 769px) {
  .nav-links {
    position: static !important;
    right: auto !important;
    width: auto !important;
    height: auto !important;
    background-color: transparent !important;
    flex-direction: row !important;
    justify-content: flex-end !important;
    align-items: center !important;
    padding: 0 !important;
    gap: 1rem !important;
    transition: none !important;
    z-index: auto !important;
    overflow: visible !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}

.nav-link {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: background-color 0.3s;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.router-link-active {
  background-color: rgba(255, 255, 255, 0.2);
}

.login-link {
  background-color: white;
  color: #072ac8;
  padding: 0.5rem 1.5rem;
  border-radius: 20px;
  transition: all 0.3s;
}

.login-link:hover {
  background-color: #f8f9fa;
  transform: translateY(-2px);
}

.logout-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  font-size: inherit;
  color: white;
  cursor: pointer;
}

.dropdown-toggle i {
  font-size: 0.8rem;
  transition: transform 0.3s;
}

.dropdown:hover .dropdown-toggle i {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  min-width: 200px;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s;
  z-index: 1000;
}

.dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: block;
  padding: 0.75rem 1rem;
  color: #2c3e50;
  text-decoration: none;
  transition: background-color 0.3s;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  color: #072ac8;
}

.admin-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #dc3545;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
}

.admin-link:hover {
  background-color: #c82333;
}

/* Mobile Styles */
@media (max-width: 768px) {
  .navbar {
    padding: 1rem 2rem;
  }

  .hamburger-menu {
    display: flex;
  }

  .nav-links {
    position: fixed;
    top: 0;
    right: -280px;
    width: 280px;
    height: 100vh;
    background-color: #072ac8;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 5rem 2rem 2rem;
    gap: 0;
    transition: right 0.3s ease, visibility 0.3s ease, opacity 0.3s ease;
    z-index: 999;
    overflow-y: auto;
    visibility: hidden;
    opacity: 0;
  }

  .nav-links.mobile-open {
    right: 0;
    visibility: visible;
    opacity: 1;
  }

  .nav-link {
    padding: 1rem;
    margin: 0.25rem 0;
    border-radius: 8px;
    font-size: 1rem;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }

  .login-link {
    background-color: white;
    color: #072ac8;
    margin-top: 1rem;
    justify-content: center;
  }

  .login-link:hover {
    background-color: #f8f9fa;
    transform: none;
  }

  .logout-link {
    justify-content: flex-start;
  }

  .admin-link {
    background-color: #dc3545;
    justify-content: flex-start;
  }

  /* Mobile Dropdown Styles */
  .dropdown.mobile-dropdown {
    width: 100%;
  }

  .dropdown-toggle {
    width: 100%;
    justify-content: space-between;
    padding: 1rem;
    margin: 0.25rem 0;
    border-radius: 8px;
    min-height: 44px;
  }

  .dropdown-toggle.active {
    background-color: rgba(255, 255, 255, 0.15);
  }

  .dropdown-toggle i.rotated {
    transform: rotate(180deg);
  }

  .dropdown-menu {
    position: static;
    background-color: rgba(255, 255, 255, 0.1);
    box-shadow: none;
    opacity: 0;
    visibility: hidden;
    transform: none;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease;
    border-radius: 8px;
    margin-top: 0.5rem;
  }

  .dropdown-menu.mobile-open {
    opacity: 1;
    visibility: visible;
    max-height: 300px;
  }

  .dropdown-item {
    color: white;
    padding: 0.75rem 1rem;
    border-radius: 4px;
    margin: 0.25rem 0;
  }

  .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
  }
}

/* Tablet Styles */
@media (max-width: 1024px) and (min-width: 769px) {
  .navbar {
    padding: 1rem 3rem;
  }

  .nav-links {
    gap: 0.75rem;
  }

  .nav-link {
    padding: 0.5rem 0.75rem;
    font-size: 0.95rem;
  }
}

/* Small Mobile Styles */
@media (max-width: 480px) {
  .navbar {
    padding: 1rem;
  }

  .nav-brand {
    font-size: 1.25rem;
  }

  .nav-links {
    width: 100%;
    padding: 4rem 1rem 2rem;
  }

  .nav-link {
    font-size: 0.95rem;
  }
}
</style>
